import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    // [types.SET_PERMIT_TYPES]: (state, items) => Vue.set(state, 'items', items),
    [types.SET_PERMIT_TYPES]: (state, items) => state.items = items,
    [types.ADD_OR_UPDATE_PERMIT_TYPE]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_PERMIT_TYPE]: (state, item) => removeItem(state, item)
}